import { Flex } from "grid-styled";
import colors from "metabase/lib/colors";

const IconWrapper = Flex.extend`
  background: ${colors["bg-medium"]};
  border-radius: 6px;
`;

export default IconWrapper;



// WEBPACK FOOTER //
// ./components/IconWrapper.jsx